import { ICustomer } from 'interfaces/i-api-loan'
import React, {
	Context,
	PropsWithChildren,
	ReactElement,
	ReactNode,
	createContext,
	useEffect,
	useState,
} from 'react'
import { getCustomerInfoCookieName } from 'exports'

interface IMyPagesCustomerInfoContextProps {
	customer: ICustomer | undefined
	refreshCustomerContext: any
}

const MyPagesCustomerInfoContext: Context<IMyPagesCustomerInfoContextProps> =
	createContext<IMyPagesCustomerInfoContextProps>({
		customer: undefined,
		refreshCustomerContext: undefined,
	})

export function MyPagesCustomerInfoContextProvider({
	children,
}: PropsWithChildren<ReactNode>): ReactElement {
	//eslint-disable-next-line
	const [customer, setCustomer] = useState<ICustomer | undefined>(undefined)

	function refreshCustomerContext() {
		const customerData = sessionStorage.getItem(getCustomerInfoCookieName())
		if (customerData) {
			const personal: ICustomer = JSON.parse(customerData.toString())
			setCustomer(personal)
		} else {
			setCustomer(undefined)
		}
	}

	useEffect(() => {
		refreshCustomerContext()
	}, [])

	return (
		<MyPagesCustomerInfoContext.Provider
			value={{
				customer,
				refreshCustomerContext,
			}}>
			{children}
		</MyPagesCustomerInfoContext.Provider>
	)
}

export default MyPagesCustomerInfoContext
